'use strict';

let reqDoc = false;
const ajaxUrl = '/wp/wp-admin/admin-ajax.php';

class DocumentViewer {

  constructor() {

    this.setDatepickers();
    this.handleFilters();
    this.handleCategories();
  }

  setDatepickers() {

    let config = {
      monthsFull: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      today: 'Aujourd\'hui',
      clear: 'Effacer',
      close: 'Fermer',
      formatSubmit: 'yyyymmdd',
    }

    $('.media-datestart').pickadate(config);
    $('.media-dateend').pickadate(config);
  }

  handleFilters() {

    var that = this;

    $('#media-filters').submit(function (e) {
      e.preventDefault();
      that.loadPage();
    });
  }

  handleCategories() {

  }

  loadPage() {

    let params = {
      pt: $('.categories').attr('data-pt'),
      type: $('.categories').attr('data-type'),
      tax: $('.categories').attr('data-tax'),
      dates: {
        start: $('input[name=date_start_submit]').val(),
        end: $('input[name=date_end_submit]').val(),
        keywords: $('input[name=search]').val(),
      },
      pagi: $('.categories').attr('data-pagi'),
    }

    if ($('.sub-categories > a.active').attr('data-category')) {
      params.cat = $('.sub-categories > a.active').attr('data-category');
    } else {
      params.cat = null;
    }

    if (reqDoc != false) {
      reqDoc.abort();
    }

    $('.results').html('Chargement...');

    reqDoc = $.ajax({
      type: "POST",
      dataType: "html",
      url: ajaxUrl,
      data: {
        'params': JSON.stringify(params),
        'action': 'get_documents',
      },

      success: function (out) {
        if (out == '') {
          out = '<span class="noresults">Aucun résultat pour cette recherche</span>';
        }
        $('.results').html(out);
      },
      error: function (out) {
        console.log(out);
      },
    })
  }

  getSearchParams(k) {
    var p = {};
    location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
      p[k] = v
    })
    return k ? p[k] : p;
  }
}

export default DocumentViewer



// WEBPACK FOOTER //
// ./scripts/document-viewer/document-viewer.js